import styled from 'styled-components'

const StyledSwitch = styled.div`
  position: relative;
  width: 45px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  .onoffswitch-checkbox {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  .onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border-radius: 25px;
  }
  .onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.1s ease-in;
  }
  .onoffswitch-inner:before,
  .onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 25px;
    padding: 0;
    line-height: 25px;
    font-size: 14px;
    color: white;
  }
  .onoffswitch-inner:before {
    content: '';
    padding-left: 10px;
    background-color: #ff3cae;
  }
  .onoffswitch-inner:after {
    content: '';
    padding-right: 10px;
    background-color: #56565c;
    text-align: right;
  }
  .onoffswitch-switch {
    display: block;
    width: 19px;
    margin: 3px;
    background: #f9f9fb;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 20px;
    border-radius: 25px;
    transition: all 0.1s ease-in;
  }
  .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
  }
  .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
  }
`

export default StyledSwitch
